module.exports = __webpack_public_path__ + "img/newsstand-cult.3f86a3ea.webp";